var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.654 6.614c.878.604.369 2.938-1.138 5.215-1.507 2.275-3.441 3.631-4.32 3.027-.878-.603-.369-2.938 1.138-5.214s3.44-3.631 4.32-3.028M1.514 6.614c-.878.604-.369 2.938 1.138 5.215 1.507 2.275 3.441 3.631 4.32 3.027.878-.603.369-2.938-1.138-5.214s-3.441-3.631-4.32-3.028M12.963 3.932c0 1.62-2.185 2.933-4.88 2.933s-4.88-1.313-4.88-2.933S5.389 1 8.084 1s4.88 1.313 4.88 2.932"
  })));
};
export default Svg16;